import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as EditIcon } from '@assets/icons/edit.svg';
import { ReactComponent as EditEye } from '@assets/icons/eye-dark.svg';

import CommonImage from '@components/CommonImage';
import DeleteModal from '@components/DeleteModal';
import DesignLink from '@components/DesignLink';
import OfferPriceListItem from '@components/offer-price/OfferPriceListItem';
import { toastError, toastSuccess } from '@components/Toast';
import ProductSlider from '@components/ProductSlider';
import ProductLock from '@components/ProductLock';

import useClickOutside from '@hooks/useClickOutside';

import ProductTags from '@features/collection/details/ProductTags';

import { removeItemFromFilterResponse } from '@store/actions/FilterAction';

import ApiClient from '@lib/apiClient';

import {
	changeDateFormat,
	checkAnyUserType,
	convertDateToLocal,
	getDesignAvailabilityStatus,
	getMinsCountFromNow,
	getShortName,
	onGetLocalFromUtc,
	packTag,
	replaceUnderLine,
	setTag,
	TASK_PRIORITY_CLASS_NAME
} from '@utils/Util';

import { BASE_FRONT_END_URL } from '@/constants/constant';

import { ReactComponent as InfoIcon } from '@/assets/icons/exclamation-mark.svg';
import { getCostingAssesmentTagColor } from '@/features/Scan/utils';
import useWindowInnerWidth from '@/hooks/useWindowInnerWidth';
import CreateDesignOption from '@/components/CreateDesignOption';

const DesignItem = ({
	design,
	index,
	selectedProducts = [],
	setSelectedProducts = () => {},
	onClickDesignImage = () => {},
	onLikeProduct,
	fromPage,
	isMyDesignTabSelected,
	isShowPrice,
	isFromNitexStudio,
	isSet = false,
	offerPriceInfo,
	onAddtoDraft,
	productWiseTags,
	fetchAllTags,
	updateProductTagOnSelect,
	showFabricStatus,
	isShowCardTop = true,
	// onClickAddTag = () => {},
	// isShowAddTagButton = true,
	onRemoveItem = () => {},
	isShowRemoveButton = false,
	setSelectedProductsWithDetails = () => {},
	selectedProductsWithDetails,
	onEditSet = () => {},
	isPack,
	setIsOpenDeleteModal = () => {},
	setSelectedSetProduct = () => {},
	setRequestType = () => {},
	onDeleteSet = () => {},
	artworkSoldStatus,
	isSoldFolder,
	onMarkProduct,
	handleProductUpdate,
	onClickToggleDesignHideFromBuyer,
	viewType,
	fetchFavProducts = () => {},
	failedTaskUpdateIds = []
}) => {
	const [openConfirmationModal, setConfirmationModal] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [isShowTags, setIsShowTags] = useState(false);
	const tagRef = useRef(null);
	const { width } = useWindowInnerWidth();
	const [selectedProductToCreateOptn, setSelectedProductToCreateOptn] = useState(null);

	const getCharacterLimit = (windowWidth, isNarrowView = false) => {
		if (isNarrowView) {
			if (windowWidth >= 1440) return 30;
			if (windowWidth >= 1360) return 25;
			if (windowWidth >= 1280) return 25;
			if (windowWidth >= 991) return 22;
			if (windowWidth >= 660) return 25;
			if (windowWidth >= 570) return 30;
			return 35;
		}

		if (windowWidth >= 1441) return 35;
		if (windowWidth >= 1366) return 35;
		if (windowWidth >= 1280) return 40;
		if (windowWidth >= 1200) return 35;
		if (windowWidth >= 991) return 45;
		if (windowWidth >= 660) return 25;
		if (windowWidth >= 570) return 70;
		if (windowWidth >= 365) return 40;
		return 30;
	};
	const onSetDetailsClick = (productId) => {
		let url = `/set/view/${productId}`;
		let currentPage = location.pathname + location.search;
		localStorage.setItem('fromRoute', currentPage);
		navigate(url);
	};

	const handleCloseTags = () => {
		setIsShowTags(false);
	};

	useClickOutside(tagRef, handleCloseTags);

	useEffect(() => {
		localStorage.setItem('fromRoute', location.pathname);
	}, []);

	const removeDesign = () => {
		ApiClient.DELETE_WITH_BODY('deleteProduct', {}, design.id)
			.then(({ data }) => {
				dispatch(removeItemFromFilterResponse(design.id));
				setConfirmationModal(false);
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				setConfirmationModal(false);
				toastError(response.data.message);
			});
	};

	const handleChange = (e) => {
		let idList = [...selectedProducts];
		let { checked } = e.target;

		if (fromPage === 'SAMPLE') {
			if (checked) {
				idList.push(design);
			} else {
				idList = idList.filter((item) => item.itemId !== design.itemId);
			}
		} else {
			if (checked) {
				idList.push(design.id);
			} else {
				idList = idList.filter((item) => item !== design.id);
			}
		}

		setSelectedProducts(idList);

		// Update the selected products with details array

		if (selectedProductsWithDetails) {
			let detailsList = Array.isArray(selectedProductsWithDetails)
				? [...selectedProductsWithDetails]
				: [];

			if (checked) {
				detailsList.push(design);
			} else {
				detailsList = detailsList.filter((item) => item.id !== design.id);
			}

			setSelectedProductsWithDetails(detailsList);
		}
	};

	const onClickCollection = (e, item) => {
		e.stopPropagation();
		window.open(`/collections/view/${item.collectionId}`);
	};

	const renderTimeCount = (publishDate) => {
		const FOURGHTY_EIGHT_HOURS_IN_MINUTES = 2880;
		if (publishDate) {
			let prev = onGetLocalFromUtc(publishDate);
			const inMins = getMinsCountFromNow(prev, 'YYYY-MM-DD HH:mm:ss');
			if (inMins < FOURGHTY_EIGHT_HOURS_IN_MINUTES) {
				return <span className="new-tag ml-1">NEW</span>;
			}
		}
	};

	const formatDate = (design, type) => {
		const format = type === 'TOOLTIP' ? 'DD MMM, YYYY' : 'DD MMM, YY';
		const formattedDate =
			fromPage === 'SAMPLE'
				? changeDateFormat(design.addedAt, 'DD/MM/YYYY', format)
				: convertDateToLocal(design.addedAt, format);

		return formattedDate ? formattedDate.toUpperCase() : formattedDate;
	};
	const itemId = fromPage === 'SAMPLE' ? design.itemId : design.id;

	const renderProductTags = (design) => {
		return design?.tagResponseList?.map((item, index) => (
			<span
				key={`tag_${index}`}
				style={{ background: item.colorCode }}
				className="status radius without-nowrap"
			>
				{item.text}
			</span>
		));
	};

	const handleSoldArtworkClick = () => {
		const getProductId = artworkSoldStatus?.artworkProductResponseList?.find(
			(item) => item?.productId === design?.id
		)?.productId;
		if (getProductId)
			window.open(
				`/designs/edit/${artworkSoldStatus?.artworkProductResponseList?.find((item) => item?.productId === design?.id)?.productId}?designToolsActiveTab=files`,
				'_blank'
			);
	};

	const isAllowedMarkAsBlock = () => {
		return checkAnyUserType(['PATTERN_MASTER', 'ADMIN', 'GARMENTS_TECH', 'FASHION_DESIGNER']);
	};

	const getSetMembersStatus = (members = []) => {
		const statusList = [];
		members?.forEach((member) => {
			statusList.push(...member?.productStatusList);
		});
		return statusList;
	};

	const renderCopyStylesDropdown = (soldDesignerStyleList) => {
		return (
			<div className="copy-styles-dropdown">
				<table className="table height-sm with-border no-hover">
					<thead>
						<tr>
							<th>Style No</th>
							<th>Order title</th>
							<th>Quantity & Price</th>
							<th>PO RCV date</th>
						</tr>
					</thead>
					<tbody>
						{soldDesignerStyleList?.map((option, index) => (
							<tr key={option?.id + index}>
								<td
									className="hover-underline"
									onClick={(event) => {
										event.stopPropagation();
										onClickDesignImage(option);
									}}
								>
									{option?.referenceNumber}
								</td>
								<td
									onClick={(event) => {
										event.stopPropagation();
									}}
								>
									<Link
										to={`/orders/view/${option.orderId}`}
										key={option.orderId}
										target="_blank"
										rel="noopener noreferrer"
										className="cursor-pointer hover-underline"
									>
										<p>{option?.orderReferenceNumber}</p>
										<p className="pt-0">{option?.orderTitle}</p>
									</Link>
								</td>
								<td>
									<p>{option?.quantity} pcs</p>
									<p>${option?.unitPrice}</p>
								</td>
								<td>{convertDateToLocal(option?.orderStartDate, 'DD MMM YY')}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	};

	return (
		<>
			<div className="design-single-item" key={`design_item_${index}`}>
				<div
					className={
						selectedProducts.length > 0
							? 'single-design-card with-editable hovered'
							: `single-design-card with-editable`
					}
				>
					<div
						className={`card-top ${failedTaskUpdateIds.includes(design.id) ? 'task-incomplete' : ''}`}
					>
						<div className="tp-hold-and-status d-flex align-items-center gap-2">
							{design?.isHoldForIssue && (
								<div className="update-basic-info-btn tp-hold">
									<p className="regular-12 gray_dark_01 white-space-nowrap">
										<InfoIcon /> <span>TP hold</span>
									</p>
								</div>
							)}

							{design?.taskPriority && (
								<div className="status-tag">
									<span className={TASK_PRIORITY_CLASS_NAME[design?.taskPriority]}>
										{design?.taskPriority}
									</span>
								</div>
							)}
						</div>

						{isShowRemoveButton && (
							<div className="edit-items d-flex align-items-center justify-content-center">
								<CommonImage
									src="/icons/trash.svg"
									className="cursor-pointer"
									onClick={() => onRemoveItem(design?.sampleId)}
									width={24}
									height={24}
								/>
							</div>
						)}
						{isFromNitexStudio && renderTimeCount(design?.publishDate)}
						{isShowCardTop && (
							<div className={`edit-items`}>
								<div className="select-and-edit d-flex justify-content-between">
									<div className="custom-chekbox">
										<div className="form-group d-flex">
											{fromPage !== 'MATERIAL' && (
												<>
													<input
														type="checkbox"
														id={`design_item_${itemId}`}
														value={itemId}
														checked={
															fromPage === 'SAMPLE'
																? selectedProducts.find(
																		(item) => item.itemId === itemId
																	)
																: selectedProducts.includes(itemId)
														}
														onChange={handleChange}
														disabled={isSoldFolder}
													/>
													<label htmlFor={`design_item_${itemId}`} />
													{showFabricStatus && (
														<Tooltip
															title="Please add body fabric for place order."
															placement="top"
															arrow
														>
															<CommonImage
																className="add-to-favorite ml-1"
																src={`/images/icons/delivery-status-icon.svg`}
																alt=""
															/>
														</Tooltip>
													)}
												</>
											)}

											{!['SAMPLE', 'MATERIAL', 'FAVOURITE_PAGE'].includes(fromPage) && (
												<CommonImage
													src={'/icons/not-favorite.svg'}
													alt={'not-favourite'}
													className="add-to-favorite"
													onClick={() => {
														onLikeProduct(design.id);
													}}
												/>
											)}
										</div>
									</div>

									{!['SAMPLE', 'MATERIAL'].includes(fromPage) && !isSet && (
										<div className="d-flex justify-content-between">
											<div>
												<Tooltip title="Edit" placement="top" arrow>
													<span
														data-dismiss="modal"
														onClick={(e) => {
															e.stopPropagation();

															window.open(
																`/designs/edit/${design.id}`,
																'_blank'
															);
														}}
														className={`edit-design-icon ${isSoldFolder || design?.isLocked ? 'cursor-none' : ''}`}
													>
														<EditIcon />
													</span>
												</Tooltip>
											</div>
											<div className="option create-option-dropdow">
												<div className="dropdown">
													<button
														className={`btn btn-default dropdown-toggle ${isSoldFolder ? 'cursor-none' : ''}`}
														type="button"
														id={`DROPDOWN__${index + 1}`}
														data-toggle="dropdown"
														aria-expanded="false"
													>
														<CommonImage src="/icons/more_icon.svg" alt="more" />
													</button>
													<ul
														className="dropdown-menu dropdown-menu-right scroll-y-label shadow-lg"
														role="menu"
														aria-labelledby={`DROPDOWN__${index + 1}`}
														x-placement="bottom-end"
													>
														<li role="presentation" className="px-4 pb-3 pt-3">
															<span
																role="menuitem"
																tabIndex="-1"
																className="font-weight-normal  text-black"
																onClick={() => {
																	navigator.clipboard.writeText(
																		`${BASE_FRONT_END_URL}/collections/list?openDesign=true&productId=${design.id}`
																	);
																	toastSuccess('Copied');
																}}
															>
																Copy design link
															</span>
														</li>
														{isAllowedMarkAsBlock() && (
															<li
																role="presentation"
																className="px-4 pb-3 pt-3"
															>
																<span
																	role="menuitem"
																	tabIndex="-1"
																	className="font-weight-normal text-black"
																	onClick={() => {
																		onMarkProduct(
																			design.id,
																			design?.isBlock ? 'edit' : 'add',
																			design?.parentCatergory
																		);
																	}}
																>
																	{design?.isBlock
																		? 'Edit block info'
																		: 'Mark as a block'}
																</span>
															</li>
														)}
														<li role="presentation" className="px-4 pb-3 pt-3">
															<span
																role="menuitem"
																tabIndex="-1"
																className="font-weight-normal  text-black"
																onClick={() => {
																	navigator.clipboard.writeText(
																		design?.referenceNumber
																	);
																	toastSuccess('Copied');
																}}
															>
																Copy design number
															</span>
														</li>
														<li role="presentation" className="px-4 pb-3 pt-3">
															<span
																role="menuitem"
																tabIndex="-1"
																className="font-weight-normal  text-black"
																onClick={() =>
																	setSelectedProductToCreateOptn(design)
																}
															>
																Create design option
															</span>
														</li>

														<li role="presentation" className="px-4 pb-3 pt-3">
															<span
																role="menuitem"
																tabIndex="-1"
																className="font-weight-normal  text-black"
																onClick={() => onClickDesignImage(design)}
															>
																Edit basic info
															</span>
														</li>
														{design?.availabilityStatus === 'SOLD' &&
															design?.isNitexProduct && (
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																>
																	<span
																		role="menuitem"
																		tabIndex="-1"
																		className="font-weight-normal text-black"
																		onClick={() => {
																			if (
																				onClickToggleDesignHideFromBuyer
																			) {
																				onClickToggleDesignHideFromBuyer(
																					design
																				);
																			}
																		}}
																	>
																		{design?.isHideFromBuyer
																			? 'Unhide'
																			: 'Hide'}{' '}
																		from buyer platform
																	</span>
																</li>
															)}
														{isPack && (
															<li role="presentation" className="px-4 pb-3">
																<span
																	style={{ color: 'red' }}
																	role="menuitem"
																	tabIndex="-1"
																	className="font-weight-normal red"
																	onClick={(e) => {
																		e.stopPropagation();
																		setIsOpenDeleteModal(true);
																		setSelectedSetProduct(design);
																	}}
																>
																	Delete Pack
																</span>
															</li>
														)}

														{isMyDesignTabSelected &&
															fromPage === 'DESIGN_PAGE' && (
																<li role="presentation" className="px-4 pb-3">
																	<span
																		style={{ color: 'red' }}
																		role="menuitem"
																		tabIndex="-1"
																		className="font-weight-normal red"
																		onClick={(e) => {
																			e.stopPropagation();
																			setConfirmationModal(true);
																		}}
																	>
																		Delete
																	</span>
																</li>
															)}
														<span className="gray_dark_02 d-block px-3 pt-2 border-top-solid">
															THIS STYLE & COPIED FROM
														</span>
														<li role="presentation" className="px-4 pb-3">
															<div className="d-flex justify-content-between">
																<p
																	role="menuitem"
																	tabIndex="-1"
																	className="copy-span"
																	data-toggle="modal"
																	data-target={'#designViewModal'}
																	onClick={(event) => {
																		event.stopPropagation();
																		onClickDesignImage(design);
																	}}
																>
																	<span className="text-black">
																		{design?.referenceNumber}
																	</span>
																</p>
																<span className="copy-style">
																	<Tooltip
																		title="Copy"
																		placement="top"
																		arrow
																	>
																		<CommonImage
																			onClick={(e) => {
																				e.stopPropagation();
																				navigator.clipboard.writeText(
																					`${design?.referenceNumber}`
																				);
																				toastSuccess('Copied');
																			}}
																			src={`/icons/copy-gray.svg`}
																			alt="copy"
																			className="copy-icon cursor-pointer"
																		/>
																	</Tooltip>
																</span>
															</div>
														</li>

														{design?.parentProduct && (
															<li role="presentation" className="px-4 pb-3">
																<div className="d-flex justify-content-between">
																	<p
																		role="menuitem"
																		tabIndex="-1"
																		className="copy-span"
																		data-toggle="modal"
																		data-target={'#designViewModal'}
																		onClick={(event) => {
																			event.stopPropagation();
																			onClickDesignImage(design);
																		}}
																	>
																		<span className="text-black">
																			{
																				design?.parentProduct
																					?.referenceNumber
																			}
																		</span>
																	</p>
																	<span className="copy-style">
																		<Tooltip
																			title="Copy"
																			placement="top"
																			arrow
																		>
																			<CommonImage
																				onClick={(e) => {
																					e.stopPropagation();
																					navigator.clipboard.writeText(
																						`${design?.parentProduct?.referenceNumber}`
																					);
																					toastSuccess('Copied');
																				}}
																				src={`/icons/copy-gray.svg`}
																				alt="copy"
																				className="copy-icon cursor-pointer"
																			/>
																		</Tooltip>
																	</span>
																</div>
															</li>
														)}

														{design?.options && (
															<>
																<span className="gray_dark_02 d-block px-3 py-2">
																	OPTIONS
																</span>
																{design?.options?.map((option) => (
																	<li
																		role="presentation"
																		className="px-4 pb-3"
																		key={option.id}
																	>
																		<div className="d-flex justify-content-between">
																			<p
																				role="menuitem"
																				tabIndex="-1"
																				className="copy-span"
																				data-toggle="modal"
																				data-target={
																					'#designViewModal'
																				}
																				onClick={
																					onClickDesignImage
																						? (event) => {
																								event.stopPropagation();
																								onClickDesignImage(
																									option
																								);
																							}
																						: undefined
																				}
																			>
																				<span className="text-black">
																					{option?.referenceNumber}
																				</span>
																			</p>
																			<span className="copy-style">
																				<Tooltip
																					title="Copy"
																					placement="top"
																					arrow
																				>
																					<CommonImage
																						onClick={(e) => {
																							e.stopPropagation();
																							navigator.clipboard.writeText(
																								`${design?.parentProduct?.referenceNumber}`
																							);
																							toastSuccess(
																								'Copied'
																							);
																						}}
																						src={`/icons/copy-gray.svg`}
																						alt="copy"
																						className="copy-icon cursor-pointer"
																					/>
																				</Tooltip>
																			</span>
																		</div>
																	</li>
																))}
															</>
														)}
													</ul>
												</div>
											</div>
										</div>
									)}
									{isSet && (
										<div className="d-flex justify-content-between align-items-center gap-1">
											<div
												style={{
													background: '#FFF',
													padding: '6px',
													marginTop: '8px'
												}}
												data-toggle="modal"
												data-target={'#designViewModal'}
												onClick={() => {
													onClickDesignImage(design);
												}}
											>
												<span className="view-icon">
													<EditEye />
												</span>
											</div>
											<div className="option create-option-dropdow">
												<div className="dropdown">
													<button
														className="btn btn-default dropdown-toggle"
														type="button"
														id={`more_menu_${design.id}`}
														data-toggle="dropdown"
														aria-expanded="false"
														// onClick={(e) => e.stopPropagation()}
													>
														<CommonImage src="/icons/more_icon.svg" alt="more" />
													</button>
													<ul
														className="dropdown-menu dropdown-menu-right scroll-y-label shadow-lg"
														role="menu"
														aria-labelledby={`more_menu_${design.id}`}
													>
														<li
															role="presentation"
															className="border-top-solid px-4 pb-3"
														>
															<span
																role="menuitem"
																tabIndex="-1"
																className="font-weight-normal"
																onClick={(e) => {
																	e.stopPropagation();
																	onEditSet('SET', design);
																	setRequestType('UPDATE');
																}}
															>
																Edit Set
															</span>
														</li>
														<li
															role="presentation"
															className="border-top-solid px-4 pb-3"
														>
															<span
																style={{ color: 'red' }}
																role="menuitem"
																tabIndex="-1"
																className="font-weight-normal red"
																onClick={(e) => {
																	e.stopPropagation();
																	onDeleteSet('SET', design);
																}}
															>
																Delete Set
															</span>
														</li>
													</ul>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						)}
						<span data-toggle="modal" data-target="#designViewModal">
							{!isSet && (
								<ProductSlider
									presentationWiseImages={design?.productPresentationResponseList || []}
									onClick={() => onClickDesignImage(design)}
									designDocuments={design?.designDocuments || []}
								/>
							)}
							{isSet &&
								design?.designDocuments
									.slice(0, 2)
									.map((item) => (
										<CommonImage
											onClick={() => onSetDetailsClick(design?.id)}
											key={item?.id}
											src={item?.docUrl}
											className="card-image"
											style={{ height: '50%', width: '100%' }}
											alt="product-image"
											isStatic={false}
										/>
									))}
						</span>
						{fromPage === 'FAVOURITE_PAGE' && (
							<>
								{design?.isLinked ? (
									<button className="action-btn link-action-btn">
										<CommonImage src="/icons/link.svg" alt="plus" />
									</button>
								) : (
									<button
										className="action-btn"
										onClick={() =>
											onAddtoDraft(design?.id, design?.orderPlacedFromThisFolder)
										}
									>
										<CommonImage src="/icons/minus.svg" width={20} />
									</button>
								)}
							</>
						)}

						{design?.hasUnseenMention && (
							<div className="comment-unread">
								<CommonImage src="/icons/comment-not-read.svg" alt="comment" />
							</div>
						)}
						<div className="design-item-status d-flex align-items-end gap-1">
							{artworkSoldStatus?.status === 'SOLD' ? (
								<div className="sold-status" onClick={handleSoldArtworkClick}>
									<span className="status red-3 d-flex align-items-center">
										Artwork Sold
										<CommonImage className="ml-1" src="/icons/link-white.svg" />
									</span>
								</div>
							) : null}

							{isSet && <div>{setTag()}</div>}
							{isPack && <div>{packTag()}</div>}
							{design?.isBlock && (
								<div>
									<span className="status yellow-1 rounded">BLOCK</span>
								</div>
							)}
						</div>
						{design?.isLocked && (
							<ProductLock
								lockedBy={design.lockedBy}
								lockedByName={design.lockedByName}
								lockedDate={design.lockedDate}
								callBack={handleProductUpdate}
								productId={design.id}
							/>
						)}
						{design?.isHideFromBuyer && <span className="dot-icon position-absolute"></span>}
					</div>

					<div
						className="card-content mt-3"
						data-toggle="modal"
						data-target="#designViewModal"
						onClick={() => onClickDesignImage(design)}
					>
						<div className="card-info">
							<div className="d-flex justify-content-between align-items-start">
								<p className="collection-title regular-12 pt-0 gray_dark_01 weight-500 mb-6">
									<DesignLink
										id={design.id}
										onClickDesignView={() => onClickDesignImage(design)}
									>
										{design?.referenceNumber}
									</DesignLink>
								</p>
								{design?.soldDesignerStyleList?.length > 0 && (
									<div className="copy-styles ml-1">
										<p className="regular-12 gray_dark_01 pt-0 d-flex align-items-center whitespace-nowrap">
											Sold to
											<span className="status yellow-3 ml-1">
												{design?.soldDesignerStyleList[0]?.brandResponse?.name}
												<CommonImage
													src="/icons/info-white.svg"
													className="ml-1"
													width={16}
													height={16}
												/>
											</span>
										</p>
										{renderCopyStylesDropdown(design?.soldDesignerStyleList)}
									</div>
								)}
							</div>
							{design?.availabilityStatus === 'ARCHIVED' && (
								<p className="regular-12 gray_dark_02 pt-0">
									Sample ID:{' '}
									<span className="regular-12 gray_dark_01 weight-500">
										{' '}
										{getShortName(design?.sampleIdentifierNoList?.join(', '))}
									</span>
								</p>
							)}

							{fromPage !== 'FAVOURITE_PAGE' &&
								design?.sampleInventoryItemResponseList?.length > 0 && (
									<p className="regular-12 gray_dark_02 pt-0">
										<span className="regular-12 gray_dark_01 weight-500">
											{
												design?.sampleInventoryItemResponseList[0]
													?.sampleInventoryLocationResponse?.countryResponse?.code
											}
											: {design?.sampleInventoryItemResponseList[0]?.sampleId}
										</span>
									</p>
								)}
							<div className="status-and-tag d-flex justify-content-between pl-0 mt-1">
								<div className="status-content d-flex gap-1">
									{!['SAMPLE'].includes(fromPage) && (
										<div className="mb-1 d-flex flex-wrap justify-content-start align-items-start gap-2">
											{design?.isSet
												? getSetMembersStatus(design?.setMemberProducts)?.map(
														(item, index) => (
															<span
																className={`status custom-tooltip status-with-border ${getDesignAvailabilityStatus(
																	item?.status
																)}`}
																key={`${index}_${item?.entity}`}
															>
																{(() => {
																	const charLimit = getCharacterLimit(
																		width,
																		viewType === 'NARROW_VIEW'
																	);
																	return item?.status?.length > charLimit
																		? `${replaceUnderLine(item?.status?.slice(0, charLimit))}...`
																		: replaceUnderLine(item?.status);
																})()}
																<span className="tooltiptext">
																	{replaceUnderLine(item?.status)}
																</span>
															</span>
														)
													)
												: design?.productStatusList?.map((item, index) => (
														<span
															className={`status custom-tooltip status-with-border ${getDesignAvailabilityStatus(
																item?.status
															)}`}
															key={`${index}_${item?.entity}`}
														>
															{(() => {
																const charLimit = getCharacterLimit(
																	width,
																	viewType === 'NARROW_VIEW'
																);
																return item?.status?.length > charLimit
																	? `${replaceUnderLine(item?.status?.slice(0, charLimit))}...`
																	: replaceUnderLine(item?.status);
															})()}{' '}
															<span className="tooltiptext">
																{replaceUnderLine(item?.status)}
															</span>
														</span>
													))}
										</div>
									)}
									<div className="status d-flex justify-content-between pl-0">
										{design.availabilityStatus === 'SOLD' &&
											!design?.soldDesignerStyleList && (
												<>
													<span className="sold d-flex align-items-center justify-content-center gap-2">
														SOLD{' '}
														<span className="count">
															{design?.numberOfResold}
														</span>{' '}
													</span>
													<ul className="solded-items shadow-4dp">
														{design?.orderRefNumbers?.map((item) => (
															<li key={item.orderId}>
																<Link
																	to={`/orders/view/${item.orderId}`}
																	key={item.orderId}
																>
																	{item?.orderRefNumber}
																</Link>
															</li>
														))}
													</ul>
												</>
											)}
									</div>
								</div>

								{/* {isShowAddTagButton &&
									(fromPage === 'FAVOURITE_PAGE' || fromPage === 'SCAN') && (
										<div className="add-tag ml-1">
											<button
												class="button text-only"
												onClick={(e) => {
													e.stopPropagation();
													setIsShowTags(true);
													onClickAddTag(design);
												}}
											>
												<CommonImage src="/icons/plus.svg" alt="plus" width={24} />{' '}
												<span class="gray_dark_03 regular-12">Add Tag</span>
											</button>
										</div>
									)} */}
							</div>
							{design?.status && (
								<div className="status-and-tag d-flex justify-content-between pl-0 mb-1">
									<div className="gap-1">
										{fromPage === 'SAMPLE' && design?.status === 'DELIVERED' && (
											<span className="regular-14 green">
												{design?.status?.replace(/_/g, ' ')}
											</span>
										)}
									</div>
								</div>
							)}
							{design?.tagResponseList?.length > 0 && (
								<div className="tags design-tags mt-1">{renderProductTags(design)}</div>
							)}
							{isShowTags && (
								<div ref={tagRef} onClick={(e) => e.stopPropagation()}>
									<ProductTags
										currentProductTagList={design?.tagResponseList}
										productId={design?.id}
										allTagList={productWiseTags}
										fetchAllTags={fetchAllTags}
										updateTagList={updateProductTagOnSelect}
									/>
								</div>
							)}
							<ul className="common-list-component mt-2">
								{design?.subCategory && (
									<li className="regular-12 gray_dark_02">
										{getShortName(design?.subCategory, 17)?.toUpperCase()}
									</li>
								)}
								<li className="regular-12 gray_dark_02">
									{
										<Tooltip
											title={<span className="regular-14">{design.addedByName}</span>}
											placement="top"
											arrow
										>
											<span className="regular-12 gray_dark_02">
												{getShortName(design.addedByName, 10)?.toUpperCase()}
											</span>
										</Tooltip>
									}
								</li>
								<li className="regular-12 gray_dark_02">{formatDate(design, '')}</li>
							</ul>
							{!design?.soldDesignerStyleList && (
								<>
									{(fromPage === 'FAVOURITE_PAGE' || fromPage === 'SCAN') &&
										design?.basePrice > 0 && (
											<ul className="common-list-component mt-1">
												<li>
													{
														<p className="semibold-12 pt-1">
															{design?.basePrice
																? `P: $${design?.basePrice.toFixed(2)}`
																: ''}{' '}
															{design?.costingReviewAssessmentResponse
																?.constant ? (
																<span
																	className={`status red-1 ml-2 ${getCostingAssesmentTagColor(design?.costingReviewAssessmentResponse?.constant)}`}
																>
																	{
																		design
																			?.costingReviewAssessmentResponse
																			?.name
																	}
																</span>
															) : (
																''
															)}
														</p>
													}{' '}
												</li>
											</ul>
										)}
									{(design?.developmentLocations ||
										design?.basePrice ||
										offerPriceInfo?.length > 0) && (
										<ul className="common-list-component mt-1 position-relative">
											{design?.basePrice && isShowPrice && (
												<li>
													<span className="mb-0 semibold-12">
														{'P:$' + parseFloat(design.basePrice).toFixed(2)}
													</span>
													{design?.costingReviewAssessmentResponse?.constant ? (
														<span
															className={`status red-1 ml-2 ${getCostingAssesmentTagColor(design?.costingReviewAssessmentResponse?.constant)}`}
														>
															{design?.costingReviewAssessmentResponse?.name}
														</span>
													) : (
														''
													)}
												</li>
											)}
											{offerPriceInfo?.length > 0 &&
												isShowPrice &&
												isFromNitexStudio && (
													<OfferPriceListItem offerPriceInfo={offerPriceInfo} />
												)}
										</ul>
									)}
								</>
							)}
							{design?.addedToFavouriteBy && (
								<>
									<p className="regular-12 gray_dark_02 text-uppercase pt-1">
										FAV BY:{' '}
										<span className="regular-12 gray_dark_01 weight-500">
											{design?.addedToFavouriteBy},{' '}
											{onGetLocalFromUtc(design?.addedToFavouriteDateTime, 'hh:mm A')},{' '}
											{onGetLocalFromUtc(
												design?.addedToFavouriteDateTime,
												'DD MMM, YYYY'
											)}
										</span>
									</p>
								</>
							)}
							{design?.collectionName && (
								<p
									className="collection-name regular-12 gray_dark_02 text-uppercase pt-1"
									onClick={(e) => onClickCollection(e, design)}
								>
									{design?.collectionName}
								</p>
							)}
						</div>
					</div>
				</div>
			</div>

			{openConfirmationModal && (
				<DeleteModal onRemove={removeDesign} onClose={() => setConfirmationModal(false)} />
			)}
			{selectedProductToCreateOptn && (
				<CreateDesignOption
					designDetails={selectedProductToCreateOptn}
					onClose={() => setSelectedProductToCreateOptn(null)}
					onSuccess={() => fetchFavProducts()}
				/>
			)}
		</>
	);
};

export default React.memo(DesignItem);
